import clsx from 'clsx'
import {ListToolbar} from './ListToolbar'
import {useMetric} from '../../core/MetricProvider'
import {MetricTab} from '../../core/_models'
import {formatDate} from '../../../../../../utils/dayJs/format'

const TABS: Array<{key: MetricTab; label: string}> = [
  {key: 'summary', label: 'Resumo'},
  {key: 'products', label: 'Produtos'},
  {key: 'clients', label: 'Clientes'},
]

const Header = () => {
  const {activeTab, setActiveTab, filterDates} = useMetric()

  return (
    <>
      <div className='d-flex flex-wrap justify-content-between align-items-stretch'>
        <div className='d-flex overflow-auto h-70px'>
          <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
            {TABS.map((tab) => (
              <li className='nav-item' key={tab.key}>
                <button
                  type='button'
                  className={clsx('nav-link', {active: activeTab === tab.key})}
                  onClick={() => setActiveTab(tab.key)}
                >
                  {tab.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div className='d-flex align-items-center h-70px'>
          <ListToolbar />
        </div>
      </div>
      {filterDates.init && filterDates.end && (
        <div className='d-flex justify-content-end me-3 pb-4'>
          Período de vendas: {formatDate(filterDates.init)} - {formatDate(filterDates.end)}
        </div>
      )}
    </>
  )
}

export {Header}
